<template>
  <div
    class="container-floating-doc"
    :class="{ show: isShow }"
    :style="styleColor"
  >
    <button
      class="toggle-view-floating-doc"
      @click="isShow = !isShow"
      :style="styleColor"
    >
      <img
        v-if="isShow"
        src="@/assets/iconos/remove_circle_white_24dp.svg"
        alt=""
      />
      <img
        v-else
        class="icon"
        src="@/assets/iconos/file_open_white_24dp.svg"
        alt=""
      />
    </button>
    <a
      class="btn-floating-doc"
      v-if="isShow"
      :href="enlace"
      target="_blank"
      rel="noopener"
    >
      <span class="btn-icon" aria-hidden="true">
        <img
          class="icon"
          src="@/assets/iconos/file_open_white_24dp.svg"
          alt=""
        />
      </span>
      {{ texto }} <span class="a11y-solo-lectura"> (Link externo).</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "BotonFlotanteDoc",
  props: {
    texto: {
      type: String,
      default: "Documento",
    },
    enlace: {
      type: String,
      default: "#",
    },
    color: {
      type: String,
      default: "#7f8c8d",
    },
  },
  data() {
    return {
      isShow: true,
      styleColor: {
        backgroundColor: this.color,
      },
    };
  },
};
</script>

<style scoped lang="scss">
$accion: #9d4637;
$space: 36px;

@keyframes iconBtn {
  0% {
    opacity: 0.25;
    top: 17px;
  }
  50% {
    opacity: 1;
    top: 5px;
  }
  100% {
    top: 17px;
    opacity: 0.25;
  }
}

.container-floating-doc {
  //background-color: $accion;
  border-radius: 25px;
  position: fixed;
  left: $space * 0.5;
  bottom: $space * 0.5;
  z-index: 99998;
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 25px;
  transition: all 0.4s ease-in-out;
  display: flex;
  align-content: center;
  &.show {
    width: 290px;
  }
  .toggle-view-floating-doc {
    //background-color: $accion;
    border-radius: 25px 0 0 25px;
    flex: 0 0 50px;
    width: 50px;
    transition: all 0.3s ease-in-out;
    margin: 0;
  }
  .btn-floating-doc {
    //white-space: nowrap;
    color: #fff;
    line-height: 50px;
    //white-space: nowrap;
    //padding-right: $space;
    transition: all 0.3s ease-in-out;
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    //flex: 1 1 80vw;
    .btn-icon {
      margin: 0 $space * 0.25;
      .icon {
        position: relative;
        animation: iconBtn 2s ease-in-out infinite;
      }
    }
    &:hover,
    &:focus {
      background-color: transparent;
    }
  }
}
</style>
